import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '@pegasus/translation';

import { timeToArray } from '@client/helpers';
import * as S from './SpecialCountdown.style';

/* eslint-disable react/no-did-mount-set-state */

export class SpecialCountdown extends React.Component {
    constructor() {
        super();
        // can not access props in constructor, set timeLeft to 0 for now
        this.state = {
            timeLeft: 0,
        };
    }

    render() {
        const [days, hours, minutes, seconds] = timeToArray(this.state.timeLeft);

        const allHours = hours + days * 24;
        const fullSeconds = Math.round(seconds);

        return (
            <S.Wrapper>
                <S.CounterContainerSt>
                    <S.FlipSt>{(allHours - (allHours % 10)) / 10}</S.FlipSt>
                    <S.FlipSt>{allHours % 10}</S.FlipSt>
                    <S.Separator>:</S.Separator>
                    <S.FlipSt>{(minutes - (minutes % 10)) / 10}</S.FlipSt>
                    <S.FlipSt>{minutes % 10}</S.FlipSt>
                    <S.Separator>:</S.Separator>
                    <S.FlipSt>{(fullSeconds - (fullSeconds % 10)) / 10}</S.FlipSt>
                    <S.FlipSt>{fullSeconds % 10}</S.FlipSt>
                </S.CounterContainerSt>
                <S.LabelsContainer>
                    <S.Label>
                        <Translate message="specialCountdown.hours" />
                    </S.Label>
                    <S.Separator />
                    <S.Label>
                        <Translate message="specialCountdown.minutes" />
                    </S.Label>
                    <S.Separator />
                    <S.Label>
                        <Translate message="specialCountdown.seconds" />
                    </S.Label>
                </S.LabelsContainer>
            </S.Wrapper>
        );
    }

    componentDidMount() {
        this.timer = setInterval(this.tick.bind(this), 1000);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    tick() {
        // Prevent negative numbers in countdowns
        let timeLeft = this.props.dateTill - Date.now();
        if (timeLeft < 0) {
            timeLeft = 0;
            if (this.timer) {
                clearInterval(this.timer);
            }
        }

        this.setState({
            timeLeft,
        });
    }
}

SpecialCountdown.propTypes = {
    dateTill: PropTypes.number.isRequired,
};

export default SpecialCountdown;
